import { render, staticRenderFns } from "./PersonaRegisterForm.vue?vue&type=template&id=65bf1138&scoped=true&"
import script from "./PersonaRegisterForm.vue?vue&type=script&lang=js&"
export * from "./PersonaRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf1138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VContainer,VIcon,VRow,VSpacer})
